import * as Constants from '../../utils/constants';

export const GetrecentData = (data: any, isHideLoader = false) => {
    return ({
        type: Constants.RECENT_LOADS,
        payload: { data, isHideLoader }
    })
}
export const GetRecent = (data: any) => {
    return ({
        type: Constants.GET_RECENT,
        payload: data

    })
}

export const clearFavoriteError = () => {
    return ({
        type: Constants.CLEAR_FAVORITE_ERROR,
        payload: undefined
    })
}






